import { Box, makeStyles, Theme } from '@material-ui/core'
import React, { FC } from 'react'
import preLoader from '../../assets/Preloader.json'
import { useLottie } from 'lottie-react'

const useStyles = makeStyles((theme: Theme) => ({
  loaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: theme.spacing(18),
  },
}))
export const BivialLoader: FC = () => {
  const classes = useStyles()
  const options = {
    animationData: preLoader,
    loop: true,
    autoplay: true,
  }

  const { View } = useLottie(options)
  return <Box className={classes.loaderContainer}>{View}</Box>
}
